import { BackButton } from 'src/components/Button';
import { StepperComponent } from 'src/components/Stepper';
import type { CheckoutProps } from '../Checkout';
import { DesktopCheckoutFormContainer, DesktopCheckoutPageContainer } from '../styles';
import { DesktopCheckoutCart } from './DesktopCheckoutCart';
import { DesktopCheckoutForm } from './DesktopCheckoutForm';

export default function DesktopCheckout({
  cart,
  orderNumber,
  isOrderPOR,
  discountPercentage,
  currency,
  sendOrder,
  cartTotal,
  isFetching,
  goBack,
  defaultAccountDetails,
  label1Key,
  label2Key,
  label3Key,
  ctaKey,
}: Readonly<CheckoutProps>) {
  return (
    <DesktopCheckoutPageContainer>
      <BackButton onClick={goBack} />
      <StepperComponent
        currentStep={!orderNumber ? 1 : /* istanbul ignore next */ 3}
        margin="1rem 0 3rem 0"
        orientation="horizontal"
        translationKey="shoppingCart"
        label1Key={label1Key ?? 'review'}
        label2Key={label2Key ?? 'addDetails'}
        label3Key={label3Key ?? 'orderComplete'}
      />
      <DesktopCheckoutFormContainer>
        <>
          <DesktopCheckoutForm
            cart={cart}
            isOrderPOR={isOrderPOR}
            discountPercentage={discountPercentage}
            currency={currency}
            sendOrder={sendOrder}
            isFetching={isFetching}
            defaultAccountDetails={defaultAccountDetails}
            ctaKey={ctaKey}
          />
          <DesktopCheckoutCart cart={cart} cartTotal={cartTotal} isFetching={isFetching} />
        </>
      </DesktopCheckoutFormContainer>
    </DesktopCheckoutPageContainer>
  );
}
